import React from "react";
import type { IconProps } from "./types";

export const LaunchIcon = React.forwardRef<SVGSVGElement, IconProps>(
  function LaunchIcon({ size = 24, width, height, className = "", fill = "currentColor", ...props }, ref) {
    return (
      <svg
        ref={ref}
        width={width || size}
        height={height || size}
        viewBox="0 0 332.786 332.786"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <g>
          <g id="Layer_5_87_">
            <g>
              <path
                d="M86.564,211.083c-5.085-5.083-7-2.529-8.131-1.397c-29.282,29.282-55.278,99.935-41.535,93.034
                c50.03-25.12,58.366-17.641,87.647-46.921c1.132-1.132,3.735-2.998-1.498-8.232L86.564,211.083z"
                fill={fill}
              />
              <path
                d="M244.419,210.691c-1.327-4.223,1.453-6.258,2.623-7.521C311.67,133.396,352.744,40.435,322.306,9.995
                c-30.278-30.276-120.372,11.998-190.127,76.16c-1.38,1.271-4.1,3.678-8.966,2.662l-21.733-5.175
                c-6.034-1.435-14.56,0.977-18.946,5.363L2.789,168.749c-4.386,4.387-2.961,8.764,3.167,9.726l57.677,9.064
                c6.128,0.964,14.73-1.837,19.115-6.224c0,0,2.976-2.984,5.966,0.005c16.496,16.494,47.15,47.148,62.866,62.865
                c3.124,3.123,0.132,6.094,0.132,6.094c-4.387,4.387-7.187,12.987-6.223,19.116l9.063,57.676c0.963,6.13,5.34,7.555,9.726,3.168
                l79.746-79.746c4.385-4.386,6.798-12.91,5.361-18.944L244.419,210.691z M226.565,107.666c-13.507-13.507-13.507-35.404,0-48.909
                c13.506-13.507,35.403-13.507,48.911,0c13.505,13.504,13.505,35.402,0,48.908C261.968,121.172,240.07,121.172,226.565,107.666z"
                fill={fill}
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }
);

export default LaunchIcon;
